"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputState = exports.InputStateTypes = void 0;
var tslib_1 = require("tslib");
var core_shared_1 = require("@ikegps/core-shared");
var mobx_1 = require("mobx");
var InputStateTypes;
(function (InputStateTypes) {
    InputStateTypes["NUMBER"] = "number";
    InputStateTypes["PASSWORD"] = "password";
    InputStateTypes["TEXT"] = "text";
    InputStateTypes["COLOR"] = "color";
})(InputStateTypes || (exports.InputStateTypes = InputStateTypes = {}));
var InputState = /** @class */ (function () {
    function InputState(label, id, type) {
        if (id === void 0) { id = core_shared_1.IkeId.generate(); }
        this._type = 'inputstate';
        /** Current value of the input displayed to the user (may be invalid) */
        this.inputValue = null;
        /** Whether the input is currently focused */
        this.focused = false;
        /** Whether the input text is currently selected */
        this.selected = false;
        /** Whether the input has been touched */
        this.touched = false;
        /** Error message for the input */
        this._error = '';
        /** Whether the input is disabled */
        this.disabled = false;
        /** Whether the input is read-only */
        this.readOnly = false;
        /** Label of the input */
        this.label = '';
        /** Type of input eg 'password' */
        this.type = undefined;
        this.isRequired = false;
        this._isAutoFocused = false;
        this.isLabelShown = true;
        /*isErrorShown is used to disable the standard error message display (at generic input level) in order to display it later im the code (usefull for composite input field, like Location which is made of 3 NumberInputField)*/
        this.isErrorShown = true;
        this.reactions = [];
        this.id = id || core_shared_1.IkeId.generate();
        this.label = label;
        this.type = type;
    }
    Object.defineProperty(InputState.prototype, "value", {
        get: function () {
            return this._value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InputState.prototype, "error", {
        get: function () {
            return this._error;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InputState.prototype, "isAutoFocused", {
        get: function () {
            return this._isAutoFocused;
        },
        set: function (value) {
            this._isAutoFocused = value;
        },
        enumerable: false,
        configurable: true
    });
    InputState.prototype.setValue = function (val) {
        this._value = val;
        this.inputValue = this.formatInputValue(val);
    };
    InputState.prototype.setInputValue = function (val) {
        this.inputValue = val;
        this._value = this.parseInputValue(val);
    };
    InputState.prototype.formatInputValue = function (val) {
        return val != null ? String(val) : null;
    };
    InputState.prototype.parseInputValue = function (val) {
        return val;
    };
    InputState.prototype.reset = function () {
        this._value = null;
        this.inputValue = null;
        this._error = '';
        this.focused = false;
        this.touched = false;
        this.disabled = false;
    };
    InputState.prototype.setFocused = function (val) {
        this.focused = val;
    };
    InputState.prototype.setTouched = function () {
        this.touched = true;
    };
    InputState.prototype.setSelected = function (selected) {
        this.selected = selected;
    };
    InputState.prototype.setError = function (error) {
        this._error = error || '';
    };
    InputState.prototype.setDisabled = function (disabled) {
        this.disabled = disabled;
    };
    InputState.prototype.setAutoFocus = function (value) {
        this.isAutoFocused = value;
        this.focused = value;
    };
    InputState.prototype.setPlaceholder = function (placeholder) {
        this.placeholder = placeholder;
    };
    InputState.prototype.hasError = function () {
        return this.error != null && this.error.length > 0;
    };
    Object.defineProperty(InputState.prototype, "isFilled", {
        get: function () {
            if (typeof this.value === 'string') {
                return this.value.trim().length > 0;
            }
            return this.value != null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InputState.prototype, "isValid", {
        get: function () {
            if (this.isRequired && !this.isFilled) {
                return false;
            }
            return !this.hasError();
        },
        enumerable: false,
        configurable: true
    });
    InputState.prototype.reaction = function (expression, effect, opts) {
        this.reactions.push((0, mobx_1.reaction)(expression, effect, opts));
    };
    InputState.prototype.onValue = function (cb) {
        var _this = this;
        this.reaction(function () { return _this.value; }, function (v) { return (0, mobx_1.runInAction)(function () { return cb(v); }); });
    };
    /**
     * This function is designed to be optionally over written by the input state that requires an onblur function
     */
    InputState.prototype.onBlur = function (e) {
        return;
    };
    /**
     * This function is designed to be optionally over written by the input state that requires an onInput function
     */
    InputState.prototype.onInput = function (e) {
        return;
    };
    InputState.prototype.destroy = function () {
        // Destroy any reactions
        this.reactions.map(function (c) { return c(); });
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], InputState.prototype, "_value", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], InputState.prototype, "value", null);
    tslib_1.__decorate([
        mobx_1.observable
    ], InputState.prototype, "inputValue", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], InputState.prototype, "focused", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], InputState.prototype, "selected", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], InputState.prototype, "touched", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], InputState.prototype, "_error", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], InputState.prototype, "error", null);
    tslib_1.__decorate([
        mobx_1.observable
    ], InputState.prototype, "disabled", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], InputState.prototype, "readOnly", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], InputState.prototype, "placeholder", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], InputState.prototype, "setValue", null);
    tslib_1.__decorate([
        mobx_1.action
    ], InputState.prototype, "setInputValue", null);
    tslib_1.__decorate([
        mobx_1.action
    ], InputState.prototype, "reset", null);
    tslib_1.__decorate([
        mobx_1.action
    ], InputState.prototype, "setFocused", null);
    tslib_1.__decorate([
        mobx_1.action
    ], InputState.prototype, "setTouched", null);
    tslib_1.__decorate([
        mobx_1.action
    ], InputState.prototype, "setSelected", null);
    tslib_1.__decorate([
        mobx_1.action
    ], InputState.prototype, "setError", null);
    tslib_1.__decorate([
        mobx_1.action
    ], InputState.prototype, "setDisabled", null);
    tslib_1.__decorate([
        mobx_1.action
    ], InputState.prototype, "setAutoFocus", null);
    tslib_1.__decorate([
        mobx_1.action
    ], InputState.prototype, "setPlaceholder", null);
    return InputState;
}());
exports.InputState = InputState;
//# sourceMappingURL=input.state.js.map